/* Paloma Living — Studio theme JS (vanilla, no dependencies) */
(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Money ---------- */
  function money(cents) {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2);
    const withComma = two.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/<[^>]*>/g, '');
  }
  window.theme.money = money;

  /* ---------- Toast ---------- */
  const toastEl = $('[data-toast]');
  let toastTimer;
  function toast(msg, ms = 2600) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove('is-visible'); setTimeout(() => toastEl.hidden = true, 300); }, ms);
  }
  window.theme.toast = toast;

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  function drawerOpen(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return;
    if (openDrawer && openDrawer !== d) drawerClose(true);
    d.hidden = false;
    requestAnimationFrame(() => { d.classList.add('is-open'); overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); });
    document.body.classList.add('is-locked');
    d.setAttribute('aria-hidden', 'false');
    openDrawer = d;
    const focusable = d.querySelector('input[type=search], input[type=text], button, a');
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 300);
    $$(`[data-drawer-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function drawerClose(keepOverlay) {
    if (!openDrawer) return;
    const d = openDrawer;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$('[data-drawer-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { d.hidden = true; }, 350);
    if (!keepOverlay) {
      overlay.classList.remove('is-visible');
      setTimeout(() => overlay.hidden = true, 300);
      document.body.classList.remove('is-locked');
    }
    openDrawer = null;
  }
  window.theme.drawerOpen = drawerOpen; window.theme.drawerClose = drawerClose;
  on(document, 'click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); drawerOpen(o.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); drawerClose(); }
  });
  on(overlay, 'click', () => drawerClose());
  on(document, 'keydown', e => { if (e.key === 'Escape') { drawerClose(); closeLightbox(); } });

  /* ---------- Cart API ---------- */
  async function cartAdd(items) {
    const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    await refreshCart();
    document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    return data;
  }
  async function cartChange(line, quantity) {
    const res = await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    const data = await res.json();
    await refreshCart();
    return data;
  }
  async function cartNote(note) {
    await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) });
  }
  async function refreshCart() {
    const res = await fetch(`${T.routes.root}?sections=cart-drawer`);
    const json = await res.json();
    const drawer = $('[data-drawer="cart"]');
    if (drawer && json['cart-drawer']) {
      const tmp = document.createElement('div'); tmp.innerHTML = json['cart-drawer'];
      const fresh = tmp.querySelector('[data-cart-drawer-inner]');
      const cur = drawer.querySelector('[data-cart-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      const count = tmp.querySelector('[data-cart-count-source]');
      if (count) $$('[data-cart-count]').forEach(el => { el.textContent = count.dataset.cartCountSource; el.dataset.count = count.dataset.cartCountSource; });
    }
    if (document.body.classList.contains('template-cart')) {
      const r = await fetch(`${window.location.pathname}?sections=main-cart`); const j = await r.json();
      const tmp = document.createElement('div'); tmp.innerHTML = j['main-cart'] || '';
      const fresh = tmp.querySelector('[data-cart-page]'); const cur = $('[data-cart-page]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
  }
  window.theme.cart = { add: cartAdd, change: cartChange, refresh: refreshCart };

  function afterAdd(btn, label) {
    if (T.cartType === 'drawer') drawerOpen('cart'); else toast(label || T.strings.added);
  }

  /* Quick add buttons */
  on(document, 'click', async e => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.classList.add('is-loading');
    try { await cartAdd([{ id: Number(b.dataset.quickAdd), quantity: 1 }]); afterAdd(b); }
    catch (err) { toast(err.message); }
    finally { b.classList.remove('is-loading'); }
  });

  /* Product form (AJAX) + insert upsell */
  $$('form[data-product-form]').forEach(form => {
    on(form, 'submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const id = Number(form.querySelector('[name=id]').value);
      const qty = Number((form.querySelector('[name=quantity]') || { value: 1 }).value) || 1;
      const items = [{ id, quantity: qty }];
      const insert = form.querySelector('[data-insert-variant]');
      if (insert && insert.checked) items.push({ id: Number(insert.dataset.insertVariant), quantity: qty });
      $$('[data-addon-variant]:checked', form).forEach(a => items.push({ id: Number(a.dataset.addonVariant), quantity: 1 }));
      btn.classList.add('is-loading');
      try { await cartAdd(items); afterAdd(btn); }
      catch (err) { toast(err.message); }
      finally { btn.classList.remove('is-loading'); }
    });
  });
  on(document, 'change', e => { const i = e.target.closest('[data-insert-variant]'); if (i) i.closest('.insert-offer').classList.toggle('is-on', i.checked); });

  /* Cart drawer & page interactions (delegated, survive re-render) */
  on(document, 'click', async e => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); rm.closest('.cart-line').classList.add('is-loading'); await cartChange(Number(rm.dataset.cartRemove), 0); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const input = q.parentElement.querySelector('input');
      let v = Number(input.value) + Number(q.dataset.qtyChange);
      if (v < Number(input.min || 0)) v = Number(input.min || 0);
      input.value = v;
      if (input.dataset.line) { input.closest('.cart-line').classList.add('is-loading'); await cartChange(Number(input.dataset.line), v); }
      else input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  on(document, 'change', async e => {
    const inp = e.target.closest('input[data-line]');
    if (inp) { inp.closest('.cart-line').classList.add('is-loading'); await cartChange(Number(inp.dataset.line), Number(inp.value)); }
    const note = e.target.closest('[data-cart-note]');
    if (note) cartNote(note.value);
  });
  on(document, 'click', async e => {
    const u = e.target.closest('[data-upsell-add]');
    if (!u) return; e.preventDefault(); u.classList.add('is-loading');
    try { await cartAdd([{ id: Number(u.dataset.upsellAdd), quantity: 1 }]); toast(T.strings.added); } catch (err) { toast(err.message); } finally { u.classList.remove('is-loading'); }
  });

  /* ---------- Discount codes in cart ---------- */
  async function applyDiscount(code) {
    if (!code) return;
    try {
      /* 1. Register the code with the checkout session first (the /discount/ route is what checkout reads). */
      await fetch(`${T.routes.root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(T.routes.cart)}`, { credentials: 'same-origin' }).catch(() => {});
      /* 2. Apply it to the AJAX cart so the drawer shows the discounted totals immediately. */
      const res = await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) });
      const data = await res.json();
      const dc = (data.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      if (dc && dc.applicable === false) { toast(T.strings.discountInvalid || "That code isn't valid for this cart"); }
      else { toast('Code applied — it will carry through to checkout'); try { localStorage.setItem('pl_discount', code); } catch (e) {} }
      await refreshCart();
    } catch (e) { toast('Could not apply that code'); }
  }
  on(document, 'click', e => {
    const a = e.target.closest('[data-discount-apply]');
    if (a) { const input = a.closest('[data-discount-form]').querySelector('input'); applyDiscount(input.value.trim()); return; }
    const r = e.target.closest('[data-discount-remove]');
    if (r) { try { localStorage.removeItem('pl_discount'); } catch (e) {} fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).then(refreshCart); }
  });
  on(document, 'keydown', e => { if (e.key === 'Enter' && e.target.matches('[data-discount-form] input')) { e.preventDefault(); applyDiscount(e.target.value.trim()); } });
  /* Re-apply a saved discount code if it has dropped off the cart (e.g. after navigating away / other apps resetting it). */
  (async function keepDiscount() {
    let saved = null; try { saved = localStorage.getItem('pl_discount'); } catch (e) {}
    if (!saved) return;
    try {
      const cart = await fetch(`${T.routes.cart}.js`, { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      if (!cart.item_count) return;
      const has = (cart.discount_codes || []).some(d => d.code.toLowerCase() === saved.toLowerCase() && d.applicable !== false);
      if (has) return;
      await fetch(`${T.routes.root}discount/${encodeURIComponent(saved)}?redirect=${encodeURIComponent(T.routes.cart)}`, { credentials: 'same-origin' }).catch(() => {});
      const res = await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: saved }) });
      const data = await res.json();
      const dc = (data.discount_codes || []).find(d => d.code.toLowerCase() === saved.toLowerCase());
      if (dc && dc.applicable !== false) { await refreshCart(); } else { try { localStorage.removeItem('pl_discount'); } catch (e) {} }
    } catch (e) { /* silent */ }
  })();


  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(wrap => {
    const input = wrap.querySelector('input[type=search]');
    const results = wrap.querySelector('[data-predictive-results]');
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      try {
        const res = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`);
        const html = await res.text();
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const inner = tmp.querySelector('#PredictiveSearchResults');
        results.innerHTML = inner ? inner.innerHTML : '';
      } catch (e) { /* silent */ }
    }, 220);
    on(input, 'input', run);
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement-rotate]').forEach(wrap => {
    const msgs = $$('.announcement__msg', wrap); if (msgs.length < 2) return;
    let i = 0; setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, Number(wrap.dataset.announcementRotate) || 4500);
  });

  /* ---------- Header stuck ---------- */
  const headerWrap = $('[data-header-wrap]');
  if (headerWrap) { const upd = () => headerWrap.classList.toggle('is-stuck', window.scrollY > 8); on(window, 'scroll', upd, { passive: true }); upd(); }

  /* ---------- Localization ---------- */
  on(document, 'change', e => { const s = e.target.closest('.localization select'); if (s) s.closest('form').submit(); });

  /* ---------- Carousels ---------- */
  $$('[data-carousel]').forEach(c => {
    const track = c.querySelector('.carousel__track');
    const prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
    const step = () => { const it = track.querySelector('.carousel__item'); return it ? it.getBoundingClientRect().width + 20 : 300; };
    on(prev, 'click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    on(next, 'click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const upd = () => { if (prev) prev.disabled = track.scrollLeft <= 2; if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
    on(track, 'scroll', debounce(upd, 60), { passive: true }); upd();
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(g => {
    const track = g.querySelector('.gallery__track');
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('.gallery__thumb', g);
    const dots = $$('.gallery__dot', g);
    const setActive = i => { thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    thumbs.forEach((t, i) => on(t, 'click', () => { slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); setActive(i); }));
    const io = new IntersectionObserver(entries => { entries.forEach(en => { if (en.isIntersecting && en.intersectionRatio > .6) setActive(slides.indexOf(en.target)); }); }, { root: track, threshold: [.6] });
    slides.forEach(s => io.observe(s));
    // variant/size switching hooks: data-media-id on options
    $$('[data-zoom]', g).forEach(z => on(z, 'click', e => { e.preventDefault(); const s = z.closest('.gallery__slide'); const img = s && s.querySelector('img'); if (img) openLightbox(img.dataset.full || img.currentSrc || img.src, img.alt); }));
  });
  let lb;
  function openLightbox(src, alt) {
    closeLightbox();
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.style.cssText = 'position:fixed;inset:0;background:rgba(255,255,255,.96);z-index:300;display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out';
    lb.innerHTML = `<img src="${src}" alt="${alt || ''}" style="max-width:100%;max-height:100%;object-fit:contain"><button type="button" aria-label="Close" style="position:absolute;top:16px;right:16px;width:44px;height:44px;border-radius:50%;background:#fff;box-shadow:0 4px 14px rgba(0,0,0,.15);font-size:22px">×</button>`;
    on(lb, 'click', closeLightbox);
    document.body.appendChild(lb); document.body.classList.add('is-locked');
  }
  function closeLightbox() { if (lb) { lb.remove(); lb = null; document.body.classList.remove('is-locked'); } }

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  const sticky = $('[data-sticky-atc]');
  const buyBtn = $('[data-main-atc]');
  if (sticky && buyBtn) {
    const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
    io.observe(buyBtn);
    on(sticky.querySelector('button'), 'click', () => { const f = $('form[data-product-form]'); if (f) f.requestSubmit(); });
  }

  /* ---------- Build-your-own set ---------- */
  $$('[data-byo]').forEach(byo => {
    const max = Number(byo.dataset.byoMax) || 4;
    const items = $$('[data-byo-item]', byo);
    const slots = byo.querySelector('[data-byo-slots]');
    const totalEl = byo.querySelector('[data-byo-total]');
    const countEl = byo.querySelector('[data-byo-count]');
    const btn = byo.querySelector('[data-byo-add]');
    let sel = [];
    const render = () => {
      items.forEach(it => { const id = it.dataset.byoItem; const isSel = sel.some(s => s.id === id); it.classList.toggle('is-selected', isSel); it.disabled = !isSel && sel.length >= max; });
      slots.innerHTML = '';
      for (let i = 0; i < max; i++) {
        const s = sel[i];
        const d = document.createElement('div'); d.className = 'byo__slot';
        d.innerHTML = s ? `<img src="${s.img}" alt=""><button type="button" class="x" data-byo-unselect="${s.id}" aria-label="Remove">×</button>` : `<span>${i + 1}</span>`;
        slots.appendChild(d);
      }
      const total = sel.reduce((a, s) => a + Number(s.price), 0);
      totalEl.textContent = money(total);
      countEl.textContent = `${sel.length} / ${max}`;
      btn.disabled = sel.length === 0;
      btn.textContent = sel.length ? `Add ${sel.length} to cart` : 'Select cushions';
    };
    on(byo, 'click', async e => {
      const un = e.target.closest('[data-byo-unselect]');
      if (un) { sel = sel.filter(s => s.id !== un.dataset.byoUnselect); render(); return; }
      const it = e.target.closest('[data-byo-item]');
      if (it && !it.disabled) {
        const id = it.dataset.byoItem;
        if (sel.some(s => s.id === id)) sel = sel.filter(s => s.id !== id);
        else if (sel.length < max) sel.push({ id, price: it.dataset.price, img: it.dataset.img });
        render();
      }
    });
    on(btn, 'click', async () => {
      btn.classList.add('is-loading');
      try { await cartAdd(sel.map(s => ({ id: Number(s.id), quantity: 1 }))); sel = []; render(); afterAdd(btn); }
      catch (err) { toast(err.message); } finally { btn.classList.remove('is-loading'); }
    });
    render();
  });

  /* ---------- Hotspots ---------- */
  on(document, 'click', e => {
    const h = e.target.closest('[data-hotspot]');
    if (h) { const was = h.classList.contains('is-active'); $$('[data-hotspot]').forEach(x => x.classList.remove('is-active')); if (!was) h.classList.add('is-active'); return; }
    if (!e.target.closest('.hotspot__card')) $$('[data-hotspot]').forEach(x => x.classList.remove('is-active'));
  });

  /* ---------- Reveal on scroll ---------- */
  const rio = new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach(el => rio.observe(el));
  setTimeout(() => $$('.reveal:not(.is-in)').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.5) el.classList.add('is-in'); }), 800);
  on(window, 'load', () => setTimeout(() => $$('.reveal').forEach(el => el.classList.add('is-in')), 2500));

  /* ---------- Collection: sort & filters (section rendering) ---------- */
  const filterForm = $('[data-filter-form]');
  const gridWrap = $('[data-collection-grid]');
  async function applyFilters(url) {
    if (!gridWrap) { window.location.href = url; return; }
    gridWrap.style.opacity = '.4';
    try {
      const sectionId = gridWrap.dataset.sectionId;
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`);
      const html = await res.text();
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-collection-grid]');
      const freshChips = tmp.querySelector('[data-filter-chips]'); const curChips = $('[data-filter-chips]');
      const freshCount = tmp.querySelector('[data-collection-count]'); const curCount = $('[data-collection-count]');
      if (fresh) gridWrap.innerHTML = fresh.innerHTML;
      if (freshChips && curChips) curChips.innerHTML = freshChips.innerHTML;
      if (freshCount && curCount) curCount.textContent = freshCount.textContent;
      history.replaceState({}, '', url);
      const top = $('[data-collection-top]'); if (top) { const y = top.getBoundingClientRect().top + window.scrollY - 140; if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' }); }
    } catch (e) { window.location.href = url; }
    finally { gridWrap.style.opacity = ''; }
  }
  if (filterForm) {
    on(filterForm, 'change', debounce(() => {
      const fd = new FormData(filterForm);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      applyFilters(`${window.location.pathname}?${params.toString()}`);
    }, 300));
    on(filterForm, 'submit', e => e.preventDefault());
  }
  on(document, 'click', e => {
    const a = e.target.closest('[data-filter-link]');
    if (a) { e.preventDefault(); applyFilters(a.getAttribute('href')); if (filterForm) { const u = new URL(a.href); $$('input[type=checkbox]', filterForm).forEach(cb => { cb.checked = u.searchParams.getAll(cb.name).includes(cb.value); }); $$('input[type=number]', filterForm).forEach(n => n.value = u.searchParams.get(n.name) || ''); } }
  });
  $$('[data-sort-select]').forEach(s => on(s, 'change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); applyFilters(u.pathname + u.search); }));

  on(document, 'click', e => { const t = e.target.closest('[data-filters-toggle]'); if (!t) return; const a = $('[data-filters-aside]'); if (a) { a.classList.toggle('is-open'); t.setAttribute('aria-expanded', a.classList.contains('is-open')); } });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime(); if (isNaN(end)) return;
    const tick = () => { let d = Math.max(0, end - Date.now()); const days = Math.floor(d / 864e5); d -= days * 864e5; const h = Math.floor(d / 36e5); d -= h * 36e5; const m = Math.floor(d / 6e4); d -= m * 6e4; const s = Math.floor(d / 1e3);
      el.innerHTML = [[days, 'days'], [h, 'hrs'], [m, 'min'], [s, 'sec']].map(([v, l]) => `<span><strong>${String(v).padStart(2, '0')}</strong><small>${l}</small></span>`).join(''); };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Video banner ---------- */
  on(document, 'click', e => { const p = e.target.closest('[data-video-play]'); if (!p) return; const v = p.closest('.video-banner').querySelector('video'); if (v) { v.muted = false; v.play(); p.remove(); } });

  /* ---------- Recently viewed (localStorage) ---------- */
  try {
    const key = 'pl_recent';
    const cur = $('[data-product-handle]');
    let list = JSON.parse(localStorage.getItem(key) || '[]');
    if (cur) { list = [cur.dataset.productHandle, ...list.filter(h => h !== cur.dataset.productHandle)].slice(0, 8); localStorage.setItem(key, JSON.stringify(list)); }
    const rv = $('[data-recently-viewed]');
    if (rv) {
      const handles = list.filter(h => !cur || h !== cur.dataset.productHandle).slice(0, Number(rv.dataset.limit) || 4);
      if (!handles.length) rv.closest('.shopify-section').hidden = true;
      else Promise.all(handles.map(h => fetch(`${T.routes.root}products/${h}?section_id=product-card-json`).then(r => r.ok ? r.text() : ''))).then(htmls => { rv.innerHTML = htmls.map(h => { const t = document.createElement('div'); t.innerHTML = h; const c = t.querySelector('.card'); return c ? `<div class="carousel__item">${c.outerHTML}</div>` : ''; }).join(''); });
    }
  } catch (e) { /* storage blocked */ }

  /* ---------- Shopify section events (theme editor) ---------- */
  /* ---------- Bundle contents: fill thumbnails/items from /products/<handle>.js (no Liquid lookup limit) ---------- */
  const productCache = {};
  async function getProductJson(handle) {
    if (productCache[handle] !== undefined) return productCache[handle];
    try { const r = await fetch(`${T.routes.root}products/${handle}.js`, { headers: { 'Accept': 'application/json' } }); productCache[handle] = r.ok ? await r.json() : null; }
    catch (e) { productCache[handle] = null; }
    return productCache[handle];
  }
  function moneyFromCents(c) {
    const f = T.moneyFormat || '${{amount}}';
    const amt = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function sizedImage(url, w) { if (!url) return ''; return url + (url.includes('?') ? '&' : '?') + 'width=' + w; }
  async function fillBundleItems(root) {
    const els = $$('[data-bundle-thumb],[data-bundle-item]', root || document).filter(el => !el.dataset.filled);
    if (!els.length) return;
    await Promise.all(els.map(async el => {
      el.dataset.filled = '1';
      const cands = (el.dataset.bundleThumb || el.dataset.bundleItem || '').split('|').filter(Boolean);
      let p = null;
      for (const h of cands) { p = await getProductJson(h); if (p) break; }
      if (!p) return;
      const img = sizedImage(p.featured_image, 300);
      if (el.hasAttribute('data-bundle-thumb')) {
        if (img) el.innerHTML = `<img src="${img}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy">`;
        return;
      }
      const media = el.querySelector('[data-bundle-item-media]');
      if (media) { media.href = `${T.routes.root}products/${p.handle}`; if (img) media.insertAdjacentHTML('afterbegin', `<img src="${img}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy">`); }
      const title = el.querySelector('[data-bundle-item-title]'); if (title) title.textContent = p.title;
      const price = el.querySelector('[data-bundle-item-price]'); if (price) { const size = price.textContent.trim(); price.textContent = (size ? size + ' · ' : '') + moneyFromCents(p.price) + ' each' + (p.available ? '' : ' · sold out'); }
    }));
  }
  fillBundleItems();
  on(document, 'shopify:section:load', e => fillBundleItems(e.target));
  document.addEventListener('theme:cart:refreshed', () => fillBundleItems());
  on(document, 'shopify:section:load', () => { $$('.reveal').forEach(el => el.classList.add('is-in')); });
})();
